import React from "react";
import { Link } from "react-router-dom";
import { Content } from "../../components/Layout";
import { Box, Flex } from "../../components/Flex";
import { Paragraph, Title } from "../../components/Text";
import { Button } from "../../components/Button";
import { CloseIcon } from "../../icons/CloseIcon";
import { VerifiedIcon } from "../../icons/VerifiedIcon";
import { UntestedIcon } from "../../icons/UntestedIcon";
import { renderFieldContent } from "../../components/Layout";
import { Page403 } from "../../components/Page403";
import { Page404 } from "../../components/Page404";
import { RemoveIcon } from "../../icons/RemoveIcon";

const ContractDetails = ({
    data={},
    loading,
    activateContract,
    onClose,
    pathname,
    forbidden,
    notFound,
    deleteContract
}) => {
    const fields = [
        { label: "Description", attr: "description" },
        { label: "Registered by", attr: "registeredBy" },
        { label: "Updated by", attr: "updatedBy" }
    ];

    if (forbidden) {
        return <Page403 />
    };

    if (notFound) {
        return <Page404 />
    };

    return(
        <Content gap={{ bottom: 21 }}>
            <Flex width="100%" justify="space-between" margin={{ bottom: "24px"}}>
                <Flex align="center" gap={{ right: 8 }}>
                    {data.inactive ? <UntestedIcon size={16} /> : <VerifiedIcon size={16} />}
                    <Title h4 isLoading={loading}>
                        {data.contractName}
                    </Title>
                </Flex>
                <CloseIcon onClick={onClose} />
            </Flex>
            <Flex flex={1} gap={{ right: 32 }}>
                <Box flex={1} gap={{ bottom: 17 }}>
                    <Flex justify="space-between" align="center">
                        <Title h4 capitalize>about contract</Title>
                    </Flex>
                    <Flex direction="column" gap={{ bottom: 20 }}>
                        {renderFieldContent(fields, data)}
                    </Flex>
                </Box>
                <Flex flex={1} direction="column" gap={{ bottom: 12 }}>
                    <Box gap={{ bottom: 17 }}>
                        <Title h4 capitalize>
                            <Link to={{pathname: pathname + "/organisations", state: { from: null }}}>
                                Organizations assigned to
                            </Link>
                        </Title>
                    </Box>
                    <Box gap={{ bottom: 17 }}>
                        <Title h4 capitalize>
                            <Link to={{pathname: pathname + "/packages", state: { from: null }}}>
                                Packages
                            </Link>
                        </Title>
                    </Box>
                </Flex>
            </Flex>
            <Flex justify="space-between">
                <Flex gap={{ right: 12 }}>
                    <Button
                        danger
                        disabled={data.inactive!=true}
                        onClick={() => deleteContract({
                            content: <Paragraph>Are you sure you want to delete the <b>{data.contractName}</b> contract?</Paragraph>,
                            id: data.contractNumber
                        })}
                    >
                        <RemoveIcon size={20} />
                        Delete
                    </Button>
                    <Button
                        danger={data.active}
                        disabled={data.inactive === undefined || loading}
                        onClick={() => activateContract({ contractName: data.contractName, activeFlag: data.inactive })}
                    >
                        {data.inactive ? "Activate" : "Deactivate" }
                    </Button>
                </Flex>
                <Button onClick={onClose}>Close</Button>
            </Flex>
        </Content>
    );
};

export { ContractDetails }